import { Modal } from 'bootstrap';
import naja from "naja";

class FormsConfirmDialogExtension {

    initialize(naja) {
        this.initializeForms();
        naja.addEventListener('complete', this.initializeForms.bind(this));
    }

    initializeForms(event) {
        $('form[data-form-confirm-dialog="true"]').each((index, form) => {
            const formConfirmDialog = new FormConfirmDialog($(form));
            formConfirmDialog.initialize();
        });
    }
}
export default FormsConfirmDialogExtension;

class FormConfirmDialog {
    constructor(form) {
        this.form = form;
        this.initialValues = {};
        this.modalOpen = false;
        this.callbackSend = false;
        this.enabledRestore = !!this.form.find('.on-change-reload-form').length;
        this.ignoreFormDialogClass = 'ignore-form-dialog';
        this.cookiePrefix = 'formData_';
        this.cookieExpireDays = 1;

        this.handleInteraction = this.handleInteraction.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
        this.handleRestoreChangedState = this.handleRestoreChangedState.bind(this);
        this.handleIgnoreFormDialogClick = this.handleIgnoreFormDialogClick.bind(this);
    }

    loadValue(element) {
        let currentValue;
        if ($(element).attr('type') === 'checkbox') {
            currentValue = $(element).prop('checked');
        } else if ($(element).is('select[multiple]')) {
            currentValue = $(element).val() || [];
        } else {
            currentValue = $(element).val();
        }
        this.initialValues[element.id] = currentValue;
    }

    // Ukládání cookie
    setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + encodeURIComponent(JSON.stringify(value)) + expires + "; path=/";
    }

    // Získání cookie
    getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) {
                try {
                    return JSON.parse(decodeURIComponent(c.substring(nameEQ.length, c.length)));
                } catch (e) {
                    return null;
                }
            }
        }
        return null;
    }

    // Smazání cookie
    deleteCookie(name) {
        document.cookie = name + '=; Max-Age=-99999999; path=/';
    }

    // Uložení dat formuláře do cookie
    saveFormData() {
        const formId = this.form.attr('id');
        if (!formId) return;

        const formData = {};
        this.form.find('input, textarea, select').each((index, element) => {
            if (!element.id) return;

            let value;
            if ($(element).attr('type') === 'checkbox') {
                value = $(element).prop('checked');
            } else if ($(element).is('select[multiple]')) {
                value = $(element).val() || [];
            } else {
                value = $(element).val();
            }
            formData[element.id] = value;
        });

        this.setCookie(this.cookiePrefix + formId, formData, this.cookieExpireDays);
    }

    // Obnovení dat formuláře z cookie
    restoreFormData() {
        const formId = this.form.attr('id');
        if (!formId) return;

        const formData = this.getCookie(this.cookiePrefix + formId);
        if (!formData) return;

        for (const elementId in formData) {
            const element = this.form.find('#' + elementId);
            if (element.length && formData[elementId]) {
                if (element.attr('type') === 'checkbox') {
                    element.prop('checked', formData[elementId]);
                } else if (element.is('select[multiple]')) {
                    element.val(formData[elementId]);
                } else {
                    element.val(formData[elementId]);
                }

                this.handleInputChange(element);
            }
        }
        this.cleanFormDataFromCookie();
    }

    cleanFormDataFromCookie() {
        const formId = this.form.attr('id');
        if (formId) {
            this.deleteCookie(this.cookiePrefix + formId);
        }
    }

    handleInputChange(element) {
        let id =  $(element).attr('id');
        element = $('#' + id);

        let currentValue;
        if ($(element).attr('type') === 'checkbox') {
            currentValue = $(element).prop('checked');
        } else if ($(element).is('select[multiple]')) {
            currentValue = element.val() || [];
        } else {
            currentValue = element.val();
        }

        if (Array.isArray(currentValue) && Array.isArray(this.initialValues[id])) {
            if (currentValue.toString() !== this.initialValues[id].toString()) {
                element.addClass('changed');
            } else {
                element.removeClass('changed');
            }
        } else if (currentValue !== this.initialValues[id]) {
            element.addClass('changed');
        } else {
            element.removeClass('changed');
        }
    }

    handleRestoreChangedState(event) {
        if (!this.enabledRestore) {
            return;
        }
        this.form.find('input, textarea, select').each((index, element) => {
            this.handleInputChange(element);
        });
    }

    // Obsluha kliknutí na prvek s třídou ignore-form-dialog
    handleIgnoreFormDialogClick(event) {
        const formId = this.form.attr('id');
        if (formId && this.isFormChanged()) {
            this.saveFormData();
        }
    }

    isFormChanged() {
        if (this.form.attr('data-disable-change-warning')) {
            return false;
        }

        let changed = false;
        this.form.find('input, textarea, select').each((index, element) => {
            if ($(element).hasClass('changed')) {
                changed = true;
                return true;
            }
        });

        return changed;
    }

    cleanChangedInputs() {
        this.form.find('input, textarea, select').each((index, element) => {
            $(element).removeClass('changed');
        });

        // Smazání cookie po úspěšném odeslání formuláře
        const formId = this.form.attr('id');
        if (formId) {
            this.deleteCookie(this.cookiePrefix + formId);
        }
    }

    initialize() {
        let id = this.form.attr('id');
        this.form = $(`#${id}`);
        if (this.form.hasClass('ignore-changes')) {
            return;
        }

        if (this.form.closest('.confirm-dialog-wrapper').length) {
            let wrapper = this.form.closest('.confirm-dialog-wrapper');
            if (wrapper.hasClass('confirm-dialog-wrapper-initialized')) {
                return;
            }
            wrapper.addClass('confirm-dialog-wrapper-initialized');
        } else {
            if (this.form.hasClass('confirm-dialog-initialized')) {
                // Pokus o obnovení dat z cookies při inicializaci
                this.restoreFormData();
                return;
            }
            this.form.addClass('confirm-dialog-initialized');
        }

        // Pokus o obnovení dat z cookies při inicializaci
        this.restoreFormData();

        this.form.find('input, textarea, select').each((index, element) => {
            this.loadValue(element);

            $(element).on('change', () => {
                this.handleInputChange(element);
            });

            $(element).on('keyup', () => {
                this.handleInputChange(element);
            });
        });

        // Přidání posluchačů událostí pro prvky s třídou ignore-form-dialog
        $(document).on('click', `.${this.ignoreFormDialogClass}`, this.handleIgnoreFormDialogClick);

        naja.uiHandler.addEventListener('interaction', this.handleInteraction);
        $(document).on('click', 'a', this.handleClick);
        window.addEventListener('beforeunload', this.handleBeforeUnload);
        naja.addEventListener('complete', this.handleRestoreChangedState);

        const modal = this.form.closest('.modal');
        if (modal.length) {
            modal.on('hide.bs.modal', (e) => {
                if (!this.callbackSend && this.isFormChanged()) {
                    e.preventDefault();
                    this.showConfirmDialog(() => {
                        modal.find('input[type=submit]').trigger('click');
                    });
                }
            });
        }
    }

    shouldIgnoreDialog(element) {
        const $element = $(element);

        return $element.parent().parent().length === 0 // pro autocomplete
            || $element.hasClass(this.ignoreFormDialogClass)
            || $element.closest(`.${this.ignoreFormDialogClass}`).length > 0;
    }

    handleInteraction(event) {
        let {element} = event.detail;
        element = $(element);

        if (this.shouldIgnoreDialog(element)) {
            // Ukládání dat při kliknutí na prvek s třídou ignore-form-dialog
            if (element.hasClass(this.ignoreFormDialogClass) || element.closest(`.${this.ignoreFormDialogClass}`).length > 0) {
                if (this.isFormChanged()) {
                    this.saveFormData();
                }
            }

            this.callbackSend = true;
            return;
        }

        if (!element.closest('form.ajax').length && !element.hasClass('list-group-item-action') && this.isFormChanged() && !this.modalOpen && $.contains(document.body, this.form[0])) {
            event.preventDefault();
            this.showConfirmDialog(() => {
                naja.makeRequest('GET', element.attr('href'), null, {history: true});
            });
        } else {
            this.callbackSend = true;
        }

        if (element.attr('name') === '_submit') {
            this.cleanChangedInputs();
        }
    }

    handleClick(event) {
        const target = $(event.target);

        if (this.shouldIgnoreDialog(target)) {
            // Ukládání dat při kliknutí na prvek s třídou ignore-form-dialog
            if (target.hasClass(this.ignoreFormDialogClass) || target.closest(`.${this.ignoreFormDialogClass}`).length > 0) {
                if (this.isFormChanged()) {
                    this.saveFormData();
                }
            }

            this.callbackSend = true;
            return;
        }

        if ((!target.closest('form.ajax').length || !target.hasClass('ajax')) && !target.hasClass('list-group-item-action') && this.isFormChanged() && !this.modalOpen && $.contains(document.body, this.form[0]) && !target.attr('data-disable-change-warning')) {
            event.preventDefault();
            this.showConfirmDialog(() => {
                window.location.href = target.attr('href');
            });
        } else {
            this.callbackSend = true;
        }
    }

    handleBeforeUnload(event) {
        if (this.isFormChanged() && !this.callbackSend) {
            event.preventDefault();
            event.returnValue = '';
        }
    }

    showConfirmDialog(yesCallback) {
        const modal = document.createElement('div');
        modal.classList.add('modal', 'fade');
        modal.tabIndex = -1;
        modal.role = 'dialog';
        modal.innerHTML = `
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Ve formuláři došlo ke změnám.</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-footer d-flex justify-content-between">
                    <button type="button" class="btn btn-secondary">Zpět</button>
                    <button type="button" class="btn btn-warning">Neukládat a pokračovat</button>
                    <button type="button" class="btn btn-success">Uložit a pokračovat</button>
                </div>
            </div>
        </div>
        `;

        document.body.appendChild(modal);

        const bootstrapModal = new Modal(modal);
        modal.querySelector('.btn-success').addEventListener(
            'click', (ev) => {
                if (!window.Nette.validateForm(this.form[0])) {
                    bootstrapModal.hide();
                    this.modalOpen = false;
                    return;
                }

                if (this.form.hasClass('ajax')) {
                    naja.uiHandler.submitForm(this.form[0]).then((response) => {
                        this.destroyCallbacks();
                        bootstrapModal.hide();
                        this.modalOpen = false;
                        this.callbackSend = true;
                        yesCallback();
                        this.callbackSend = false;
                    });
                } else {
                    bootstrapModal.hide();
                    this.modalOpen = false;
                    this.form.submit();
                }
            }
        );
        modal.querySelector('.btn-warning').addEventListener(
            'click', () => {
                this.destroyCallbacks();

                bootstrapModal.hide();

                if ($('.modal.show').length) {
                    $('.modal-backdrop').remove();
                    $('.modal.show').remove();

                    this.modalOpen = false;
                    this.callbackSend = false;
                } else {
                    this.modalOpen = false;
                    this.callbackSend = true;
                    yesCallback();
                    this.callbackSend = false;
                }

                $('.modal-backdrop').remove();
                $('.modal.show').remove();
            }
        );
        modal.querySelector('.btn-secondary').addEventListener(
            'click', () => {
                bootstrapModal.hide();
                this.modalOpen = false;
            }
        );
        modal.addEventListener('hidden.bs.modal', () => {
            this.modalOpen = false;
        });

        this.modalOpen = true;
        bootstrapModal.show();
    }

    destroyCallbacks() {
        naja.uiHandler.removeEventListener('interaction', this.handleInteraction);
        $(document).off('click', 'a', this.handleClick);
        $(document).off('click', `.${this.ignoreFormDialogClass}`, this.handleIgnoreFormDialogClick);
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }
}
